<template>
  <b-columns is-multiline>
    <b-column class="is-full">
      <category
        name="Protection"
        :items="getProtectionResources"
      />
    </b-column>
    <b-column class="is-full">
      <category
        name="Decontamination"
        :items="getDecontaminationResources"
      />
    </b-column>
    <b-column class="is-full">
      <category
        name="Sampling"
        :items="getSamplingResources"
      />
    </b-column>
    <b-column class="is-full">
      <category
        name="Manuals"
        :items="getManualResources"
      />
    </b-column>
  </b-columns>
</template>

<script>
import Category from './Category'
import { mapGetters } from 'vuex'

export default {
  components: {
    Category
  },
  computed: {
    ...mapGetters([
      'getProtectionResources',
      'getSamplingResources',
      'getDecontaminationResources',
      'getManualResources'
    ])
  }
}
</script>
